import { useEffect, useState } from "react";
import { PlugZap } from "lucide-react";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";

export default function Experiments() {
  const [exps, setExps] = useState([]);
  useEffect(() => { http.get("/admin/experiments").then((r) => setExps(r.data)).catch(() => {}); }, []);
  const anySample = exps.some((e) => e.sample || e.demo);

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Conversion Experimentation</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Experiments</h1>
      <p className="text-[#6B665E] text-sm mb-5">Optimization knowledge compounds over time. Safety, privacy, legal and price-truth content is never experimented on.</p>

      <Card className="p-4 mb-6 border-[#9E4F4F]/30 bg-[#9E4F4F]/5" data-testid="experiments-not-connected">
        <div className="flex items-start gap-2 text-sm text-[#9E4F4F]">
          <PlugZap size={16} className="mt-0.5 shrink-0" />
          <div>
            <span className="font-semibold">Experiment runtime: NOT CONNECTED.</span> Live A/B variant assignment and real-time conversion tracking are a Phase 2 capability. {anySample && "The entries below are illustrative sample configurations — their views, purchases and CR are NOT real."}
          </div>
        </div>
      </Card>

      <div className="space-y-4">
        {exps.map((e) => (
          <Card key={e.id} className="p-6">
            <div className="flex items-center justify-between mb-2 gap-2">
              <h3 className="font-display text-lg text-[#1A1918]">{e.name}</h3>
              <div className="flex items-center gap-2">
                {(e.sample || e.demo) && <span className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#C49A5A]/15 text-[#8a6a2e]">Sample</span>}
                <span className={`text-xs px-2 py-0.5 rounded-full ${e.status === "running" ? "bg-[#667A66]/12 text-[#4d6b4d]" : "bg-[#E5E1D8] text-[#6B665E]"}`}>{e.status}</span>
              </div>
            </div>
            <p className="text-[#6B665E] text-sm mb-4">{e.hypothesis} · <span className="text-[#8A998C]">{e.page}</span></p>
            <div className="grid sm:grid-cols-2 gap-3">
              {["a", "b"].map((v) => (
                <div key={v} className="border border-[#E5E1D8] rounded-lg p-4">
                  <div className="text-xs text-[#8A998C] uppercase mb-1">Variant {v.toUpperCase()}</div>
                  <div className="text-[#1A1918] text-sm mb-2">{e[`variant_${v}`]}</div>
                  <div className="text-sm text-[#6B665E]">{e.metrics?.[v]?.views || 0} views · {e.metrics?.[v]?.purchases || 0} purchases {(e.sample || e.demo) && <span className="text-[#C49A5A]">(sample)</span>}</div>
                  <div className="font-display text-xl text-[#9F634E] mt-1">{e[`${v}_cr`]}% CR</div>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
